export function formatInteger(value) {
  return new Intl.NumberFormat("en-US", { maximumFractionDigits: 0 }).format(Number(value || 0));
}

export function formatCompactNumber(value) {
  return new Intl.NumberFormat("en-US", { notation: "compact", maximumFractionDigits: 1 }).format(Number(value || 0));
}

export function formatCurrency(value) {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
  }).format(Number(value || 0));
}

export function formatCompactCurrency(value) {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 2,
  }).format(Number(value || 0));
}

export function formatPercent(value) {
  return `${Number(value || 0).toFixed(1)}%`;
}

export function formatDecimal(value) {
  return Number(value || 0).toFixed(2).replace(/\.00$/, "");
}

export function formatSeriesValue(series, value) {
  if (!series) return formatInteger(value);
  if (series.type === "line" && /pct|percent/i.test(series.key)) return formatPercent(value);
  if (/spend/i.test(series.key)) return `$${formatInteger(value)}`;
  return formatInteger(value);
}

export function formatQuarterlyMetricValue(metric, value) {
  const decimals = Number.isFinite(metric?.decimals) ? metric.decimals : 1;
  const formatted = Number(value || 0).toFixed(decimals);
  return metric?.format === "currency" ? `$${formatted}` : formatted;
}

export function formatStateSpendValue(value) {
  return `$${formatInteger(value)}k`;
}

export function buildSelectOptions(options) {
  return options.map((option) => ({ label: option, value: option }));
}

export function buildBreakdownQuery(filters) {
  const params = new URLSearchParams();
  params.set("financialYear", filters.financialYear);
  params.set("financialQuarter", filters.financialQuarter);
  filters.parentCompany.forEach((value) => params.append("parentCompany", value));
  filters.childCompany.forEach((value) => params.append("childCompany", value));
  filters.carrier.forEach((value) => params.append("carrier", value));
  filters.service.forEach((value) => params.append("service", value));
  return params;
}
